export function components(): Array<string> {
  return [
    "CoverPage",
    "DisclaimerPage",
    "ContactsPage",
    "DashboardPage",
    "FitnessActivityPage",
    "SuperScorePage",
    "SsBeneficiaryPage",
    "SsBalancePage",
    "SsInsurancePage",
    "SsInvestmentPage",
    "SsRetirementPage",
    "FundOverviewPage",
    "TransactionBalancePage",
    "OverviewPage",
    "TrendsPage",
    "RankingPage",
    "AsfaBalancePage",
    "InsurancePage",
    "MembershipPage",
    "StateMapPage",
    "InvestmentPage",
    "FundMixPage",
    "CustomBiSectionPage",
    "BackPage",
  ]
}
